<mat-card
  class="flex flex-col gap-3 items-start justify-between rounded-md bg-mat-ef-revolution-grey-500 h-full w-full"
>
  <div class="w-full">
    <div
      class="w-full flex font-efSans text-xl font-black text-mat-ef-revolution-primary-500 leading-normal mb-1"
    >
      <T
        str="Support and vehicle questions"
        key="customerPortal.customer-portal.support-vehicle-card.title"
        tags="customer-portal, 3.41"
      ></T>
    </div>

    <div class="text-sm text-efSans text-mat-ef-revolution-primary-500">
      <T
        str="Do you have questions about your contract or your vehicle? Would you like to speak to your local contact person?"
        key="customerPortal.customer-portal.support-vehicle-card.text"
        tags="customer-portal, 3.41"
      ></T>
    </div>
  </div>

  <div class="btn-rounded-btn w-full md:w-fit"
       (click)="handleSupportCallback()"
       (keydown.enter)="handleSupportCallback()">
    <T
      str="Request callback"
      key="customerPortal.customer-portal.support-vehicle-card.button"
      tags="customer-portal, 3.41">
    </T>
  </div>
</mat-card>
